export const myStickersEn = {
  title: 'Stickers',
  boardStickersTitle: 'Stickers and Automation',
  tabBoardStickers: 'Board Stickers',
  tabStickerLibrary: 'Sticker Library',
  createSticker: 'Create',
  otherBoardsStickers: 'Other boards stickers',
  search: 'Search by title, project, board, author',
  removeFromBoard: 'Remove from board',
  removeFromSystem: 'Remove from system',
  addToCurrentBoard: 'Add to current board',
  name: 'Name. Author',
  projectAndBoards: 'Project (Board)',
  action: 'Action',
  system: 'System',
  infoSystem: 'Created by YouGile team',
  infoUser: 'Sticker author: ',
  cancel: 'Cancel',
  removeStickerTitle: 'Delete sticker from system?',
  removeStickerFromBoardContent:
    'This sticker is used only on this board and when removed from the board, it will be removed from the system. After that, it will also stop being displayed on all tasks on which it was previously attached.',
  removeStickerFromSystemContent:
    'When removed this sticker is removed from all boards and will also stop being displayed on all tasks on which it was previously attached.',
  settingsApplied: 'Settings applied',
  removeStickerFromBoard: 'Remove sticker from board',
  editSticker: 'Edit sticker',
  editStates: 'Edit states',
  createTextSticker: 'Create text sticker',
  createStickerWithDateIntervals: 'Create sticker sprint',
  showSettings: 'Show settings',
  whenCreatingTask: 'When creating a task:',
  requireToDefineValue: 'Require a value',
  stickerTitleBeforeValue:
    'Show the name in a sticker on the board in front of the value',
  showNumericStickersSum: 'Show sum of sticker values next to column name',
  offerToDefineValue: 'Offer a value',
  setDefaultValue: 'Assign value automatically when creating a task:',
  selectStateByDefault: 'Select state',
  hideSettings: 'Hide settings',
  creatingSticker: 'Create a New Sticker',
  stickerName: 'Sticker Name',
  stickerType: 'Sticker Type',
  stickerWithStatuses: 'Status',
  stickerWithText: 'Text field',
  stickerWithNumber: 'Number field',
  stickerWithDateIntervals: 'Sprint',
  stickerWithStatusesTitle: 'Status',
  stickerWithStatusesDescription:
    'Customize task priorities, task assessments or any task categories by adding different states.',
  stickerWithDateIntervalsTitle: 'Time Interval',
  stickerWithDateIntervalsDescription:
    'Specify dates to define a time period, such as a Scrum sprint.',
  stickerWithTextTitle: 'Brief Text',
  stickerWithTextDescription:
    'Input customer details directly on the card: name, phone, and address.',
  stickerWithNumberTitle: 'Numeric Value',
  stickerWithNumberDescription:
    'Specify a quantity, costs or any number on the card. The sum of numbers can be shown in the column.',
  states: 'States',
  numericalStickerStates:
    'The sticker has no states, you can enter numbers directly in the sticker on the task.',
  numericalStickerStatesSum:
    'In the sticker settings, there is a summation of sticker values in the column header.',
  textStickerStates:
    'The sticker has no states, you can enter arbitrary text directly in the sticker on the task.',
  addState: 'Add State',
  AddInterval: 'Add an interval',
  ownDates: 'Own dates',
  noNameOnCreateWarning: 'To create a sticker, you must specify a name',
  noNameOnEditWarning: 'To edit a sticker, you must specify a name',
  namePlaceholder: 'Type a name…',
  withoutIcon: 'Leave without icon',
  selectValue: 'Select value',
  currentInterval: 'Current interval',
  assignDefaultValue: 'Assign value automatically when creating a task',
  assignDefaultValueToAuthor: 'Task author',
  assignDefaultValueToUser: 'Specific user',
  selectUser: 'Select user',
  filterByCurrentValue: 'Automatically filter by current value',
  stopwatchOnCreate: 'Automatically run when a task appears on the board',
  workingHoursInColumns: 'Working hours in columns:',
  transferringTaskBetweenColumns: `Restart when transferring a task between columns,
    show sum by columns`,
  stopAfterTaskComplete: 'Stop after task complete',
  sum: 'Sum',
  stickerOrderHasChanged:
    'The order of the stickers on the board has been changed',
  displayAsTimer: 'Display as a timer on the card if less than 1 day is left',
  remainingBeforeDeadline: 'Remaining before the deadline',
  deadlineOverdueBy: 'Deadline overdue by',
  editSettings: 'Settings',
  automations: (count: number) => `Automations: (${count})`,
  backToBoardStickers: 'Back to board stickers',
  addStickerFromOtherBoard: 'Add sticker from other boards',
  creatingStickerType: (
    type: 'string' | 'sprint' | 'text' | 'numeric'
  ): string => {
    switch (type) {
      case 'string':
        return 'Create sticker with states'
      case 'sprint':
        return 'Create sticker sprint'
      case 'text':
        return 'Create sticker with text field'
      case 'numeric':
        return 'Create sticker with number field'
    }
  },
  editingSticker1: 'Editing sticker',
  editingSticker2: 'of company',
  stickerAutomationOnBoard1: 'Automation of sticker',
  stickerAutomationOnBoard2: 'on board',
  editingWarning1: `Changes will be applied to sticker`,
  editingWarning2: 'on all boards and tasks',
  editingWarning3: 'in company',
  nameStartsWithDotError: 'Sticker name cannot start with a dot.'
}

export const myStickersRu: typeof myStickersEn = {
  title: 'Стикеры',
  boardStickersTitle: 'Стикеры и автоматизация',
  tabBoardStickers: 'Стикеры доски',
  tabStickerLibrary: 'Библиотека стикеров',
  createSticker: 'Создать',
  otherBoardsStickers: 'Стикеры других досок',
  search: 'Поиск по названию, проекту, доске, автору',
  removeFromBoard: 'Убрать с доски',
  removeFromSystem: 'Убрать из системы',
  addToCurrentBoard: 'Добавить на текущую доску',
  name: 'Название. Автор',
  projectAndBoards: 'Расположение. Проект (Доска)',
  action: 'Действие',
  system: 'Системный',
  infoSystem: 'Создано командой YouGile',
  infoUser: 'Автор стикера: ',
  cancel: 'Отменить',
  removeStickerTitle: 'Удалить стикер из системы?',
  removeStickerFromBoardContent:
    'Этот стикер используется только на этой доске и при удалении с доски он будет удалён из системы. После этого он также перестанет отображаться на всех задачах, на которых он раньше был прикреплён',
  removeStickerFromSystemContent:
    'После удаления стикер удалится со всех досок и перестанет отображаться на всех задачах, на которых он раньше был прикреплён',
  settingsApplied: 'Настройки применены',
  removeStickerFromBoard: 'Удалить стикер с доски',
  editSticker: 'Редактировать стикер',
  editStates: 'Настроить состояния',
  createTextSticker: 'Создать текстовый стикер',
  createStickerWithDateIntervals: 'Создать стикер спринт',
  showSettings: 'Показать настройки',
  whenCreatingTask: 'При создании задачи:',
  requireToDefineValue: 'Требовать указать значение',
  stickerTitleBeforeValue:
    'Показывать название в стикере на доске перед значением',
  showNumericStickersSum:
    'Показывать сумму значений стикера рядом с названием колонки',
  offerToDefineValue: 'Предлагать указать значение',
  setDefaultValue: 'Присваивать значение автоматически при создании задачи:',
  selectStateByDefault: 'Выберите состояние',
  hideSettings: 'Скрыть настройки',
  creatingSticker: 'Создание нового стикера',
  stickerName: 'Название стикера',
  stickerType: 'Тип стикера',
  stickerWithStatuses: 'Набор состояний',
  stickerWithText: 'Текстовое поле',
  stickerWithNumber: 'Числовое поле',
  stickerWithDateIntervals: 'Спринт',
  stickerWithStatusesTitle: 'Набор заданных состояний',
  stickerWithStatusesDescription:
    'Создайте несколько состояний, отметьте их цветом. Подходит для приоритетов, оценки сложности.',
  stickerWithDateIntervalsTitle: 'Спринт',
  stickerWithDateIntervalsDescription:
    'Задайте интервал дат, например, для спринтов.',
  stickerWithTextTitle: 'Свободное текстовое поле',
  stickerWithTextDescription:
    'Поле для ввода: пишите прямо на карточке. Например, данные клиента: имя, телефон, адрес.',
  stickerWithNumberTitle: 'Свободное числовое поле',
  stickerWithNumberDescription:
    'Укажите количество, например, бюджет. Включите суммирование в колонке.',
  states: 'Состояния',
  numericalStickerStates:
    'Стикер не имеет состояний, вы можете вводить числа прямо в стикере на задаче.',
  numericalStickerStatesSum:
    'В настройках стикера есть суммирование значений стикера в шапке колонки.',
  textStickerStates:
    'Стикер не имеет состояний, вы можете вводить произвольный текст прямо в стикере на задаче.',
  addState: 'Добавить состояние',
  AddInterval: 'Добавить интервал',
  ownDates: 'Свои даты',
  noNameOnCreateWarning: 'Чтобы создать стикер, необходимо указать название',
  noNameOnEditWarning: 'Чтобы изменить стикер, необходимо указать название',
  namePlaceholder: 'Введите название…',
  withoutIcon: 'Оставить без иконки',
  selectValue: 'Выберите состояние',
  currentInterval: 'Текущий интервал',
  assignDefaultValue: 'Присваивать значение автоматически при создании задачи',
  assignDefaultValueToAuthor: 'Автора задачи',
  assignDefaultValueToUser: 'Конкретного пользователя',
  selectUser: 'Выбрать пользователя',
  filterByCurrentValue: 'Автоматически фильтровать по текущему значению',
  stopwatchOnCreate: 'Автоматически запускать при появлении задачи на доске',
  stickerOrderHasChanged: 'Порядок стикеров на доске изменён',
  workingHoursInColumns: 'Время работы в колонках:',
  transferringTaskBetweenColumns: `Перезапускать при переносе задачи между колонками,
    показывать сумму по колонкам`,
  stopAfterTaskComplete: 'Останавливать при выполнении задачи',
  sum: 'Сумма',
  displayAsTimer:
    'Отображать в виде таймера на карточке, если осталось менее 1 дня',
  remainingBeforeDeadline: 'До дедлайна осталось',
  deadlineOverdueBy: 'Дедлайн просрочен на',
  editSettings: 'Настроить',
  automations: (count: number) => `Автоматизации: (${count})`,
  backToBoardStickers: 'Назад к списку стикеров доски',
  addStickerFromOtherBoard: 'Добавить стикер с других досок',
  creatingStickerType: (
    type: 'string' | 'sprint' | 'text' | 'numeric'
  ): string => {
    switch (type) {
      case 'string':
        return 'Создание стикера с набором состояний'
      case 'sprint':
        return 'Создание стикера спринт'
      case 'text':
        return 'Создание стикера с текстовым полем'
      case 'numeric':
        return 'Создание стикера с числовым полем'
    }
  },
  editingSticker1: 'Изменение стикера',
  editingSticker2: 'компании',
  stickerAutomationOnBoard1: 'Автоматизация стикера',
  stickerAutomationOnBoard2: 'на доске',
  editingWarning1: `Изменения применятся к стикеру`,
  editingWarning2: 'на всех досках и задачах',
  editingWarning3: 'в компании.',
  nameStartsWithDotError: 'Имя стикера не может начинаться с точки.'
}
